import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppInsightsService } from '../app-insights.service';
import { IDocumentModel, ITenantDocumentSaveInputModel, ITenantDocumentResponseModel } from 'src/app/Shared/models/DocumentModel';
import { IApiResponse } from 'src/app/Shared/interface';
import { IMergerInputModel } from 'src/app/Shared/models/DocumentMerge';
import {AppService} from '../app.service';

@Injectable({
  providedIn: 'root',
})

export class DocumentService {
  private baseURL = this.appService.config.apiBaseUrl;
  constructor(private http: HttpClient,
              private appinsights: AppInsightsService,
              private appService: AppService) {
  }

  //Notifying message to e-Signature component : expects
  sendMessageForESignature(data): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let url = `${this.baseURL}/PushMessage/SendMessageForESignature`;

    return this.http.post<any>(url, data, options)
        .pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );
  }

  loadDocument(fileName): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let url = `${this.baseURL}/PdfViewer/Load`;
    return this.http.post<any>(url,fileName, options)
        .pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );
  }

  // GetDocumentForSign(DocumentRequestModel: IDocumentModel): Observable<IDocumentResponseModel> {
  //   const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  //   const url = `${this.baseURL}/Document/GetDocumentForSign`;
  //   return this.http.post<IDocumentResponseModel>(url, DocumentRequestModel, options)
  //     .pipe(
  //       map(res => {
  //         return res;
  //       }),
  //       catchError(this.handleError)
  //     );
  // }

//   SaveSignedDocument(documentInputModel: IDocumentSaveInputModel): Observable<IApiResponse> {
//     const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }),};
//     const url = `${this.baseURL}/Document/SaveSignedDocument`;
//     return this.http.post<IApiResponse>(url, documentInputModel, options)
//         .pipe(
//             map(res => {
//                 return res;
//             }),
//             catchError(this.handleError)
//         );
// }

uploadAndSaveTenantDocument(documentInputModel: ITenantDocumentSaveInputModel): Observable<ITenantDocumentResponseModel> {
  const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }),};
  const url = `${this.baseURL}/CustomerDocuments/UploadAndSaveTenantDocument`;
  return this.http.post<ITenantDocumentResponseModel>(url, documentInputModel, options)
      .pipe(
          map(res => {
              return res;
          }),
          catchError(this.handleError)
      );
}

GenerateTenantDocument(documentModel: IMergerInputModel): Observable<any> {
  const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
  let url = `${this.baseURL}/DocumentMerger/GenerateTenantDocument`;
  return this.http.post<any>(url, documentModel, options)
      .pipe(
          map(res => {
              return res;
          }),
          catchError(this.handleError)
      );
}

deleteLeaseSampleAgreementForOnlineRental(tenantLetterId, facilityId): Observable<ITenantDocumentResponseModel> {
  const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }),};
  const url = `${this.baseURL}/DocumentMerger/DeleteLeaseSampleAgreementForOnlineRental?tenantLetterId=${tenantLetterId}&facilityId=${facilityId}`;
  return this.http.post<ITenantDocumentResponseModel>(url, options)
      .pipe(
          map(res => {
              return res;
          }),
          catchError(this.handleError)
      );
}

getEnvelopeStatus(envelopeCode): Observable<any> {
  return this.http.get<any>(
      `${this.baseURL}/BatchUnsignedDocument/GetEnvelopeStatus?envelopeCode=${envelopeCode}`,
      { observe: 'response' })
      .pipe(
          map(res => {
              const resp = res.body as any;
              return resp;
          }),
          catchError(this.handleError)
      );
}

getDownloadPDFPreview(envelopeCode): Observable<any> {
  return this.http.get<any>(
      `${this.baseURL}/BatchUnsignedDocument/GetDownloadPDFPreview?envelopeCode=${envelopeCode}`,
      { observe: 'response' })
      .pipe(
          map(res => {
              const resp = res.body as any;
              return resp;
          }),
          catchError(this.handleError)
      );
}
GetGenerateTenantDocumentStatus(documentStausModel): Observable<any>{
  return this.http.post<any>(
    `${this.baseURL}/DocumentMerger/GetGenerateTenantDocumentStatus`,documentStausModel,{ observe: 'response' })
    .pipe(
        map(res => {
            const resp = res.body as any;
            return resp;
        }),
        catchError(this.handleError)
  );

}



  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
